import Vue from "vue";

const i18n = {
  install(Vue) {
    Vue.prototype._b = (function(bind) {
      return function(data, tag, value) {
        if (value && value.$scopedSlots) {
          data.scopedSlots = {
            ...data.scopedSlots,
            ...value.$scopedSlots
          };
          delete value.$scopedSlots;
        }
        return bind.apply(this, arguments);
      };
    })(Vue.prototype._b);
  }
};

Vue.use(i18n);
